// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"542792f5","448":"2c4c9429","501":"770b1409","610":"2b0f3e88","778":"31d6cfe0"}[chunkId] + ".chunk.css";
};